import React, { memo, MouseEventHandler, ReactNode } from "react";
import { RotatingLines } from "react-loader-spinner";

interface CustomButtonProps {
  type?: "button" | "submit" | "reset";
  rounded?: string;
  border?: string;
  bg?: string;
  textColor?: string;
  padding?: string;
  textTransform?: string;
  addclass?: string;
  handleClick?: MouseEventHandler<HTMLButtonElement>;
  icon?: ReactNode;
  btntext?: string | ReactNode;
  isLoading?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  type = "button",
  rounded = "rounded-2xl",
  border = "border-0",
  textColor = "text-white",
  padding = "p-2.5 px-5",
  textTransform = "capitalize",
  addclass = "",
  handleClick,
  icon,
  btntext,
  isLoading = false,
  bg = isLoading ? "bg-gray-400" : "bg-darkCyan",
}) => {
  return (
    <button
      type={type}
      className={`flex items-center transition duration-300 ease-in-out  hover:shadow-[5px_5px_0_1px_#D4EBEC] justify-center ${rounded} ${border} ${bg} ${textColor} ${padding} ${textTransform} ${addclass}`}
      onClick={handleClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <RotatingLines
          width="25"
          visible={true}
          strokeColor="white"
          strokeWidth="3"
          animationDuration="0.75"
          ariaLabel="rotating-lines-loading"
        />
      ) : (
        <>
          {btntext}
          {icon}
        </>
      )}
    </button>
  );
};

export default memo(CustomButton);
